'use client'

import cx from 'classnames'
import React, { Fragment, ReactNode, useEffect, useRef, useState } from 'react'

import '@/components/Common/Toggle/Toggle.scss'

type ClickComponentType = {
  onClick: () => void
  open: boolean
}

export default function Toggle({
  ClickComponent,
  children,
}: {
  // eslint-disable-next-line no-unused-vars
  ClickComponent: ({ onClick, open }: ClickComponentType) => ReactNode
  children: ReactNode
}) {
  const [open, setOpenedNovelty] = useState(false)
  const ref = useRef<HTMLInputElement>(null)
  const [maxHeight, setMaxHeight] = useState(0)
  useEffect(() => {
    if (ref.current && ref.current.offsetHeight > maxHeight) {
      setMaxHeight(ref.current.offsetHeight)
    }
  }, [ref.current && ref.current.offsetHeight])

  return (
    <>
      <ClickComponent onClick={() => setOpenedNovelty((prevState) => !prevState)} open={open} />
      <div
        className={cx('c-toggle', {
          'c-toggle--open': open,
          'c-toggle--close': !open,
        })}
        style={maxHeight > 0 ? { height: open ? maxHeight : 0 } : {}}
        ref={ref}
      >
        <div
          className={cx('c-toggle-inner', {
            'c-toggle-inner--open': open,
            'c-toggle-inner--close': !open,
          })}
        >
          {children}
        </div>
      </div>
    </>
  )
}
